/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_GoalInputs */

const en_us2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main goal`)
};

const pt_br2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const es_419_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const pt_pt2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo principal`)
};

const fr_fr2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif principal`)
};

const de_de2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptziel`)
};

const it_it2_search_field_goal = /** @type {(inputs: Search_Field_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo principale`)
};

/**
* | output |
* | --- |
* | "Main goal" |
*
* @param {Search_Field_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_goal = /** @type {((inputs?: Search_Field_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_goal(inputs)
	if (locale === "es-419") return es_419_search_field_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_goal(inputs)
	if (locale === "de-DE") return de_de2_search_field_goal(inputs)
	if (locale === "it-IT") return it_it2_search_field_goal(inputs)
	return en_us2_search_field_goal(inputs)
});
export { search_field_goal as "search.field_goal" }